module.exports = __webpack_public_path__ + "media/theme/icon__stock--out-7124aae7.svg";